import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';

export const PackagingTableView = (props) => {

    const columns = [
    {
        dataField: 'brand',
        text: 'Brand'
    }, {
        dataField: 'manufacturerCode',
        text: 'Manufacturer Code'
    },{
        dataField: 'packagingType',
        text: 'Packaging Type'
    }, {
        dataField: 'weight',
        text: 'Weight (g)'
    }, {
        dataField: 'cost',
        text: 'Cost (£)',
        formatter: (cell) => `£${cell}`
    }, {
        dataField: 'size',
        text: 'size'
    }



];

    return <BootstrapTable keyField='_id' data={props.packagings} columns={columns} />

}